export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rmc-feedback/es/index.js
// module id = 1410
// module chunks = 0